import React from 'react';
import PropTypes from 'prop-types';
import {Component} from 'react/lib/ReactBaseClasses';
import TweenLite from "gsap";
import {EASE} from '../../utils/easing';
import styled from 'styled-components';

const Container = styled.div`
	.effect{
		filter:url(#filter-2);
	}
	
	.outline {
		fill:#ffffff;
	}
	
	.wave {
		fill: #FF3334;
	}
	
	.full-score {
		opacity: 0;
	}
`;

// <editor-fold desc="svg definitions">
const svg = `<svg version="1.1" viewBox="0 0 100 100"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink">
	
	<defs>
		<mask id="mask" x="0" y="0" width="100%" height="100%">
			<rect x="0" y="0" width="100%" height="100%" fill="black"/>
      <path fill="white" d="M83.2922,65.7951c-3.5173,0-5.5891,1.4566-7.9886,3.1432
				c-0.2482,0.175-0.4961,0.349-0.7486,0.5239c-7.9089,5.5525-12.9391,6.6906-18.0589,6.6906
				c-14.9818,0-27.1706-11.732-27.1706-26.1528c0-6.9169,2.8027-13.4627,7.8912-18.4317c5.0999-4.9792,11.8507-7.7218,19.0086-7.7218
				c7.5962,0,12.7491,3.1651,17.792,6.6936c0.2437,0.1688,0.4863,0.3391,0.7466,0.5223c2.3988,1.6862,4.4703,3.1425,7.987,3.1425
				c2.9041,0,5.5483-0.865,7.8624-2.5732c2.7563-2.0545,4.2136-4.9972,4.2136-8.5103c0-3.2469-1.1018-5.8253-3.6969-8.6355
				C84.7828,7.5245,71.2773,0.5,55.4135,0.5c-13.7043,0-26.544,5.2713-36.1534,14.8424c-4.5995,4.5809-8.211,9.892-10.7345,15.7853
				C5.9413,37.1623,4.6312,43.5118,4.6312,50c0,6.4941,1.3046,12.8452,3.8767,18.8762c2.5149,5.8959,6.116,11.2064,10.7034,15.7833
				C28.8028,94.2294,41.6598,99.5,55.4135,99.5c7.3342,0,14.8006-1.4867,21.5916-4.2996c6.0447-2.5028,11.2532-5.943,14.6792-9.7004
				c2.5826-2.7962,3.6845-5.3746,3.6845-8.6215c0-3.6128-1.3834-6.4005-4.2283-8.5211
				C89.5606,67.1877,86.9187,65.7951,83.2922,65.7951z"/>
		</mask>
		
		<linearGradient id="gradient" gradientUnits="objectBoundingBox" gradientTransform="rotate(90)">
      <stop offset="0%" stop-color="#FF007F" />
      <stop offset="100%" stop-color="#FF3334" />
    </linearGradient>

		<g id="score-fill">
			<rect class="wave" width="100" height="100" y="100" x="0"/>
		</g>
		
		<g id="score-wave">
			<path fill="url(#gradient)" d="M188.4,101.6c-8.3,0-8.3,2-16.7,2c-8.3,0-8.3-2-16.7-2c-8.3,0-8.3,2-16.7,2c-8.3,0-8.3-2-16.7-2
				c-8.3,0-8.3,2-16.7,2c-1.7,0-3.4-0.1-5.1-0.3c-3.8-0.6-5.4-1.7-11.6-1.7c-8.3,0-8.3,2-16.7,2c-8.3,0-8.3-2-16.7-2s-8.3,2-16.7,2
				c-8.3,0-8.3-2-16.7-2c-8.3,0-8.3,2-16.7,2c-1.7,0-3.4-0.1-5.1-0.3v3.2v14.1h200v-14.1v-3.2C196.2,102.7,194.6,101.6,188.4,101.6z">
				<animateTransform attributeName="transform"
				 type="translate"
				 from="-100 0"
				 to="0 0"
				 begin="0s"
				 dur="6.66s"
				 repeatCount="indefinite"/>
			 </path>
		</g>
		
		<g id="outline-c">
			<path id="path-1" class="outline" d="M83.2922,65.7951c-3.5173,0-5.5891,1.4566-7.9886,3.1432
				c-0.2482,0.175-0.4961,0.349-0.7486,0.5239c-7.9089,5.5525-12.9391,6.6906-18.0589,6.6906
				c-14.9818,0-27.1706-11.732-27.1706-26.1528c0-6.9169,2.8027-13.4627,7.8912-18.4317c5.0999-4.9792,11.8507-7.7218,19.0086-7.7218
				c7.5962,0,12.7491,3.1651,17.792,6.6936c0.2437,0.1688,0.4863,0.3391,0.7466,0.5223c2.3988,1.6862,4.4703,3.1425,7.987,3.1425
				c2.9041,0,5.5483-0.865,7.8624-2.5732c2.7563-2.0545,4.2136-4.9972,4.2136-8.5103c0-3.2469-1.1018-5.8253-3.6969-8.6355
				C84.7828,7.5245,71.2773,0.5,55.4135,0.5c-13.7043,0-26.544,5.2713-36.1534,14.8424c-4.5995,4.5809-8.211,9.892-10.7345,15.7853
				C5.9413,37.1623,4.6312,43.5118,4.6312,50c0,6.4941,1.3046,12.8452,3.8767,18.8762c2.5149,5.8959,6.116,11.2064,10.7034,15.7833
				C28.8028,94.2294,41.6598,99.5,55.4135,99.5c7.3342,0,14.8006-1.4867,21.5916-4.2996c6.0447-2.5028,11.2532-5.943,14.6792-9.7004
				c2.5826-2.7962,3.6845-5.3746,3.6845-8.6215c0-3.6128-1.3834-6.4005-4.2283-8.5211
				C89.5606,67.1877,86.9187,65.7951,83.2922,65.7951z"/>
		</g>
	</defs>
	
	<filter filterUnits="objectBoundingBox" height="100%" id="filter-2" width="100%" x="0" y="0">
		<feGaussianBlur  in="SourceAlpha" result="shadowBlurInner1" stdDeviation="5"></feGaussianBlur>
		<feOffset  dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
		<feComposite  in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1">
			</feComposite>
		<feColorMatrix  in="shadowInnerInner1" type="matrix" values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0"></feColorMatrix>
	</filter>
	
	<g id="c">
		<use xlink:href="#outline-c" />
		
		<g class="effect">
			<path d="M83.2922,65.7951c-3.5173,0-5.5891,1.4566-7.9886,3.1432c-0.2482,0.175-0.4961,0.349-0.7486,0.5239
				c-7.9089,5.5525-12.9391,6.6906-18.0589,6.6906c-14.9818,0-27.1706-11.732-27.1706-26.1528
				c0-6.9169,2.8027-13.4627,7.8912-18.4317c5.0999-4.9792,11.8507-7.7218,19.0086-7.7218c7.5962,0,12.7491,3.1651,17.792,6.6936
				c0.2437,0.1688,0.4863,0.3391,0.7466,0.5223c2.3988,1.6862,4.4703,3.1425,7.987,3.1425c2.9041,0,5.5483-0.865,7.8624-2.5732
				c2.7563-2.0545,4.2136-4.9972,4.2136-8.5103c0-3.2469-1.1018-5.8253-3.6969-8.6355C84.7828,7.5245,71.2773,0.5,55.4135,0.5
				c-13.7043,0-26.544,5.2713-36.1534,14.8424c-4.5995,4.5809-8.211,9.892-10.7345,15.7853C5.9413,37.1623,4.6312,43.5118,4.6312,50
				c0,6.4941,1.3046,12.8452,3.8767,18.8762c2.5149,5.8959,6.116,11.2064,10.7034,15.7833C28.8028,94.2294,41.6598,99.5,55.4135,99.5
				c7.3342,0,14.8006-1.4867,21.5916-4.2996c6.0447-2.5028,11.2532-5.943,14.6792-9.7004c2.5826-2.7962,3.6845-5.3746,3.6845-8.6215
				c0-3.6128-1.3834-6.4005-4.2283-8.5211C89.5606,67.1877,86.9187,65.7951,83.2922,65.7951z"/>
		</g>
	</g>
	
	<use xlink:href="#score-fill" mask="url(#mask)" />
	<use xlink:href="#score-wave" mask="url(#mask)" />
	<use xlink:href="#outline-c" id="full-score" class="full-score" />
</svg>`;

//</editor-fold>

class ScoreC extends Component {
	percentNow = 0;
	levelUpAnimation = false;
	levelUpAnimationDelay = 5;
	
	componentWillReceiveProps(nextProps) {
		// console.log('ScoreC componentWillReceiveProps, nextProps: ', nextProps);
		this.updatePosition(nextProps.percent, true);
	}
	
	componentDidMount() {
		// console.log('ScoreC componentDidMount, nextProps: ', this.props);
		this.updatePosition(this.props.percent, false);
	}
	
	componentWillUnmount() {
		TweenLite.killTweensOf('#score-fill');
		TweenLite.killTweensOf('#score-wave');
	}
	
	updatePosition(percent, animate) {
		// console.log('ScoreC updatePosition, percent: ', percent, ' percentNow:' + this.percentNow);
		// percent smaller = next level achieved > show animation, delay next update which will happen immediately
		if (percent < this.percentNow) {
			this.levelUp();
		}
		this.percentNow = percent;
		
		const delay = this.levelUpAnimation ? this.levelUpAnimationDelay / 2 : 0;
		const time = (!animate || this.levelUpAnimation) ? 0 : 3;
		TweenLite.to('#score-fill', time, {y : -percent, ease : EASE.easeOut, delay : delay});
		let yValue = -percent - 5;
		if (percent === 0) {
			yValue = -2;
		}
		TweenLite.to('#score-wave', time, {y : yValue, ease : EASE.easeOut, delay : delay});
	}
	
	levelUp = () => {
		this.levelUpAnimation = true;
		TweenLite.to('#full-score', this.levelUpAnimationDelay / 2, {opacity : 1, ease : EASE.easeOut, onComplete : this.levelUpped});
	};
	
	levelUpped = () => {
		this.levelUpAnimation = false;
		TweenLite.to('#full-score', this.levelUpAnimationDelay / 2, {opacity : 0, ease : EASE.easeOut, onComplete : this.levelUppedFinished});
	};
	
	levelUppedFinished = () => {
		this.levelUpAnimation = false;
	};
	
	render() {
		return (
			<Container dangerouslySetInnerHTML={{__html : svg}}/>
		);
	}
}

ScoreC.propTypes = {
	percent : PropTypes.number
};

ScoreC.defaultProps = {
	percent : 0
};

export default ScoreC;


// WEBPACK FOOTER //
// ./src/ui/score/ScoreC.js